






























import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator';
import BButton from 'buefy/src/components/button/Button.vue';
import {Action, Getter, State, Mutation} from 'vuex-class';
import BInput from 'buefy/src/components/input/Input.vue'; // @ is an alias to /src
import BField from 'buefy/src/components/field/Field.vue'; // @ is an alias to /src
import BSelect from 'buefy/src/components/select/Select.vue';
import {MAFUser} from '@/store/User/types'; // @ is an alias to /src
import Slider from '../common/Slider.vue';
import {OptionType} from '@/components/common/types';

import MAFDropdown from '@/components/common/MAFDropdown.vue';
import {Lookup, LookupIcon} from '@/store/types';

const namespace = 'userState';
@Component({
    components: {
        BField,
        BButton,
        BInput,
        BSelect,
        Slider,
        MAFDropdown,
    },
})

export default class DiagnosisInfo extends Vue {
    @Prop(MAFUser) public readonly self!: MAFUser;
    @Action('updateSelfDoc', {namespace}) public updateSelfDoc: any;
    @State('diagnosis', {namespace}) public diagnosis: Lookup | undefined;

    @Getter('getDiagnosis', {namespace})  public diagnoses: string[] | undefined;
    @Getter('getUserType', {namespace})  public userTypes: string[] | undefined;
    @Mutation('setSelf', {namespace: 'userState'}) public setSelf: any;

    public BASE_URL: string;
    public update: MAFUser ;
    public isLoading: boolean;
    public sliderOptions: OptionType[];
    public diagnosisMessage: string;
    public severityMessage: string;
    // public userTypeMessage: string;
    constructor() {
        super();
        this.isLoading = false;
        this.BASE_URL = process.env.BASE_URL ? process.env.BASE_URL : '';
        this.update =  this.self;
        this.sliderOptions = [
            {value: 1, display: 'Low'},
            {value: 2, display: ''},
            {value: 3, display: 'Medium'},
            {value: 4, display: ''},
            {value: 5, display: 'High'},
        ];
        this.diagnosisMessage = '';
        this.severityMessage = '';
        // this.userTypeMessage = '';
    }

    get diagnosisIdentifier(): string {
        const self = this;
        if (this.update.diagnosis && this.diagnosis && this.diagnosis.values) {
            let found = '';
            this.diagnosis.values.forEach((d) => {
                if (d.display === self.update.diagnosis) {
                    found = this.update.diagnosis ? this.update.diagnosis : '';

                }
            });
            if (found) {
                return found;
            } else {
                return 'Other';
            }

        }
        return '';

    }
    public selectedDiagnosis(selected: LookupIcon) {
        this.update.diagnosis = selected.display;
    }
    public async submit(event: any) {
        event.preventDefault();
        let failed: boolean = false;
        this.isLoading = true;
        if (!this.update.diagnosis) {
            failed = true;
            this.diagnosisMessage =  'Please select a diagnosis to continue.';
        }
        if (this.update.diagnosis && this.update.diagnosis.toLowerCase() === 'other' && !this.update.otherdiagnosis) {
            failed = true;
            this.diagnosisMessage =  'Please enter a diagnosis in the other box to continue.';
        }
        if (!this.update.severity) {
            failed = true;
            this.severityMessage = 'Please select a severity level to continue.';
        }
        /*if (!this.update.userType) {
            failed = true;
            this.userTypeMessage = 'Please select a user type to continue.';
        }*/
        if (failed) {
            this.isLoading = false;
            return;
        }
        this.update.signUpPhase = 3;
        const save = this.update.toPlainObj();
        if (this.update.diagnosis && this.update.diagnosis.toLowerCase() === 'other') {
            // @ts-ignore
            save.diagnosis = this.update.diagnosis;

        }

        try {
            await this.updateSelfDoc(save);
            this.setSelf(save);
        } catch (error) {
            this.$snackbar.open({
                message: 'Error saving user please try again.',
                type: 'is-danger',
                indefinite: true,
            });
        }

        this.isLoading = false;
    }


    public onSelected(selected: OptionType) {
        this.update.severity = +selected.value;
    }
}
